export default { sha: 'd1881945e76d5c22d0d6b0b99cb1c9ed9797dc19', buildNumber: 'undefined' }
